module.exports = {
    integers: 'integers',
    ranges: 'ranges',
    keys: 'keys'
};
